<template>
  <section class="w-full box p-4" id="filtro-ejecucion">
    <div v-if="loading" class="rounded-md icono-carga flex justify-center items-center">
      <LoadingIcon icon="puff" color="rgba(0,0,0,0.4)"/>
    </div>
    <div class="accordion-item" v-else>
      <div id="faq-accordion-content-1" class="accordion-header flex justify-between">
        <button class="accordion-button text-base font-medium focus:outline-none text-primary-1 dark:text-white" type="button" data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                aria-controls="faq-accordion-collapse-1">
          Filtros de busqueda
        </button>
        <button class="btn btn btn-warning" @click="openModalVizualizarDetalle(filters.client)">
          Visualizar detalle
        </button>
      </div>
      <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show mt-2"
           aria-labelledby="faq-accordion-content-1" data-bs-parent="#faq-accordion-1">
        <div class="accordion-body text-gray-700 dark:text-gray-600 leading-relaxed">
          <div class="grid grid-cols-6 gap-x-6 gap-y-2">
            <div class="col-span-6 sm:col-span-2">
              <label for="client" class="block text-sm font-medium text-gray-700">Clientes:</label>
              <select class="form-select form-select-sm mt-1" id="client" v-model="filters.client">
                <option :value="null">-- Seleccione una opción --</option>
                <option v-for="(item, index) in nameClient" :key="index" :value="item.firt_name"> {{ item.firt_name }}</option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-2">
              <label for="department" class="block text-sm font-medium text-gray-700">Departamentos:</label>
              <select class="form-select form-select-sm mt-1" id="department" v-model="filters.department">
                <option :value="null">-- Seleccione una opción --</option>
                <option v-for="item in Departament" :key="item"> {{ item }}</option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-2">
              <label class="block text-sm font-medium text-gray-700">Servicios:</label>
              <Multiselect
                class="mt-1"
                placeholder="-- Seleccione una opción --"
                v-model="filters.service"
                mode="tags"
                :searchable="true"
                :options="Service"
              />
            </div>
            <div class="col-span-6 sm:col-span-2">
              <label for="start_year" class="block text-sm font-medium text-gray-700">Año:</label>
              <select class="form-select form-select-sm mt-1" id="start_year" v-model="filters.year">
                <option :value="null">-- Seleccione una opción --</option>
                <option v-for="(row,k) in Year" :key="k" :value="row">{{ row }}</option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-2">
              <label for="start_month" class="block text-sm font-medium text-gray-700">Mes Inicial:</label>
              <select class="form-select form-select-sm mt-1" id="start_month" v-model="filters.month_start">
                <option :value="null">-- Seleccione una opción --</option>
                <option v-for="(row,k) in months" :key="k" :value="row.id">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-2">
              <label for="end_month" class="block text-sm font-medium text-gray-700">Mes Final:</label>
              <select class="form-select form-select-sm mt-1" id="end_month" v-model="filters.month_end">
                <option :value="null">-- Seleccione una opción --</option>
                <option v-for="(row,k) in filterMonths" :key="k" :value="row.id">{{ row.name }}</option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-2">
              <label for="start_month" class="block text-sm font-medium text-gray-700">Régimen:</label>
              <select class="form-select form-select-sm mt-1" id="regimen" v-model="filtro.regimen">
                <option :value="null">-- Seleccione una opción --</option>
                <option value="Contributivo">CONTRIBUTIVO</option>
                <option value="Subsidiado">SUBSIDIADO</option>
              </select>
            </div>
            <div class="col-span-6 sm:col-span-2">
              <label for="end_month" class="block text-sm font-medium text-gray-700">Género:</label>
              <select class="form-select form-select-sm mt-1" id="genero" v-model="filtro.genero">
                <option :value="null">-- Seleccione una opción --</option>
                <option value="Masculino">MASCULINO</option>
                <option value="Femenino">FEMENINO</option>
              </select>
            </div>
            <div class="col-span-2">
              <div class="flex flex-wrap w-inputNumber">
                <div class="">
                  <label for="start_year" class="block text-sm font-medium text-gray-700">Rango edad:</label>
                  <InputNumber id="inputnumberi" v-model="filtro.edad1" :class="`${classInvalid} p-inputtext-sm mt-1`" :min="0" :max="120" />
                </div>
                <div class=" pl-2">
                  <label for="start_year" class="block text-sm font-medium text-gray-700">&nbsp;</label>
                  <InputNumber id="inputnumberi" v-model="filtro.edad2" class=" p-inputtext-sm mt-1" :min="filtro.edad1" :max="120" />
                </div>
                <div class="ml-auto mt-auto">
                  <label for="start_year" class="block text-sm font-medium text-gray-700">&nbsp;</label>
                  <button
                    type="button"
                    class="bg-green-600 text-white px-5 py-2 ml-3 rounded-md mt-1"
                    @click="Buscar()"
                  >
                    Buscar
                  </button>
                </div>
              </div>
              <div class="row">
                <label id="inputEdad" class="block text-sm" style="visibility: hidden">La edad 1 debe ser menor</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VizualizarDetalle ref="verDetalle" :client="filters" />
  </section>
</template>
<script>
import { warning } from '../../../../../../../libs/mensajes'
import { Client, Service, Departament, Year, loading, getFilters } from './hook'
import { onMounted, computed, ref, watch } from 'vue'
import VizualizarDetalle from '../vizualizarDetalle'
import { useStore } from 'vuex'
export default {
  name: 'FilterEjecucion',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  components: {
    VizualizarDetalle
  },
  setup (props, { emit }) {
    const store = useStore()
    const classInvalid = ref('')

    const months = [
      { id: '01', name: 'Enero' },
      { id: '02', name: 'Febrero' },
      { id: '03', name: 'Marzo' },
      { id: '04', name: 'Abril' },
      { id: '05', name: 'Mayo' },
      { id: '06', name: 'Junio' },
      { id: '07', name: 'Julio' },
      { id: '08', name: 'Agosto' },
      { id: '09', name: 'Septiembre' },
      { id: '10', name: 'Octubre' },
      { id: '11', name: 'Noviembre' },
      { id: '12', name: 'Diciembre' }
    ]
    const filterMonths = computed(() => {
      return months.filter((itemMonth) => {
        return parseInt(props.modelValue.month_start) <= parseInt(itemMonth.id)
      })
    })

    const Buscar = () => {
      var elemento = document.getElementById('inputEdad')
      if (filtro.value.edad1 > filtro.value.edad2) {
        elemento.className += ' input-alert'
        classInvalid.value = 'p-invalid'
      } else {
        elemento.className -= ' input-alert'
        classInvalid.value = ''
        emit('buscar', filtro.value)
      }
    }

    onMounted(() => {
      getFilters()
      // Buscar()
    })
    const verDetalle = ref()

    /**/
    const nameClient = computed(() => {
      const clienteAuth = store.getters['auth/getPeople']
      if (clienteAuth.firt_name === 'COOSALUD') {
        return [
          { firt_name: 'COOSALUD' },
          { firt_name: 'PHARMEDIS' }
        ]
      } else {
        return [{ firt_name: clienteAuth.firt_name }]
      }
    })

    const filtro = ref(props.modelValue)

    watch(filtro, () => {
      actualizaEdad()
    })

    const actualizaEdad = () => {
      if (filtro.value.edad1 > filtro.value.edad2) {
        filtro.value.edad2 = filtro.value.edad1
        // console.log('watch')
      }
    }
    const openModalVizualizarDetalle = (cliente) => {
      if (cliente) {
        verDetalle.value.toggle()
      } else {
        warning('Seleccione un cliente')
      }
    }
    return {
      classInvalid,
      Buscar,
      filters: props.modelValue,
      filtro,
      Client,
      Service,
      Departament,
      Year,
      loading,
      months,
      filterMonths,
      openModalVizualizarDetalle,
      verDetalle,
      nameClient
    }
  }
}
</script>

<style >
@media print{
  #filtro-ejecucion{
    display: none;
  }
}
.w-inputNumber input{
  width: 70px!important;
  height: 30px!important;
}
.input-alert{
  color: red;
  visibility: visible!important;
}

</style>
